"use client";
import React, { useEffect, useState, useRef } from "react";
import Image from "next/image";
import style from "@/styles/Homepage/SuccessStories.module.scss";
import ResponsiveSwiper from "../ResponsiveSwiper";
import OrangeSpan from "@/Ui_Elements/OrangeSpan/OrangeSpan";

const SuccessStories = ({ data }) => {
  const card = data?.card || [];
  const countersRef = useRef([]);
  const [counts, setCounts] = useState(card.map(() => "0"));

  useEffect(() => {
    if (!card.length) return;

    // Ensure the ref array matches the current number of items
    countersRef.current = countersRef.current.slice(0, card.length);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Lower for mobile reliability
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const index = countersRef.current.findIndex((el) => el === entry.target);
        const item = card[index];

        if (entry.isIntersecting && index !== -1 && item?.Counter && !entry.target.dataset.animated) {
          entry.target.dataset.animated = "true"; // Prevent duplicate animations

          const targetCount = parseInt(item.Counter.replace(/\D/g, ""), 10) || 0;
          const suffix = item.CounterNumber.replace(/\d+/g, "");

          let start = 0;
          const duration = 1500;
          const stepTime = Math.max(15, Math.floor(duration / targetCount));

          const updateCounter = () => {
            if (start < targetCount) {
              start += Math.ceil(targetCount / 100);
              if (start > targetCount) start = targetCount;
              setCounts((prevCounts) => {
                const newCounts = [...prevCounts];
                newCounts[index] = `${start}${suffix}`;
                return newCounts;
              });
              setTimeout(updateCounter, stepTime);
            }
          };

          updateCounter();
        }
      });
    }, observerOptions);

    // Ensure elements are being observed
    setTimeout(() => {
      countersRef.current.forEach((el) => {
        if (el) observer.observe(el);
      });
    }, 500); // Added delay for Swiper render timing

    return () => observer.disconnect();
  }, [card]);

  return (
    <section className={style["SuccessStories"]}>
      <div className="container">
        <div className="tx-center">
          <OrangeSpan text={data?.orangeSpanText} classname={style["HowVidyalayaOrangeSpan"]} />
          <h3 className="commonsectiontitle">{data?.sectiontitle}</h3>
        </div>

        <div className={style["mainbox"]}>
          <ResponsiveSwiper
            swiperConfig={{
              spaceBetween: 20,
              centeredSlides: true,
              slidesPerView: "auto",
              loop: true,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false,
              },
              pagination: { clickable: true },
              breakpoints: {
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2, spaceBetweenSlides: 10, centeredSlides: false },
                992: { slidesPerView: 3 },
              },
              navigation: true,
              className: "commonswiperclass prevnextpadding whitearrow w-100",
            }}
            windowwidth={767}
          >
            {card.map((item, index) => (
              <div
                className={style["div-3"]}
                key={index}
                ref={(el) => (countersRef.current[index] = el)}
              >
                <div className={`${style["d-flex"]} ${style["success-stories-content"]}`}>
                  <Image
                    loading="lazy"
                    height={50}
                    width={50}
                    alt="VidyalayaImages"
                    src={item.image}
                    className={`img-fluid ${style["ic_success_stories"]}`}
                  />
                  <div className={`${style["ps-3"]} my-auto`}>
                    <p className={style["count"]}>
                      {item.Counter ? counts[index] || item.CounterNumber : item.CounterNumber}
                    </p>
                    <p className={style["count-para"]}>{item.SubCounter}</p>
                  </div>
                </div>
              </div>
            ))}
          </ResponsiveSwiper>
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
